import { Separator } from '@givebutter/primitives/separator';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Details from 'assets/js/pages/engage/metrics/EngageMetricsDetailsSection';
import { FilterGroupBar } from 'components/filter/filters-next/FilterGroupBar';
import { FilterGroupProvider } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProvider } from 'components/filter/filters-next/FilterProvider';
import { transformSavedFilterGroups } from 'components/filter/filters-next/downstream';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { useInitFilters } from 'components/filter/filters-next/useInitFilters';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';
import { OutboundFilters } from 'types/request';

const EngageMetricsDetails = () => {
    const getMessage = useCurrentEngageMessage();
    const message = getMessage.data;

    return (
        <div className="flex flex-col gap-y-2">
            <Details.Root>
                <Details.Title>To:</Details.Title>
                <Details.Content>
                    <Details.Row className="border-b border-gray-100">
                        {message?.delivery_count} contacts
                    </Details.Row>
                    <Details.Row className="border-b border-gray-100">
                        <Details.RowTitle>Segment</Details.RowTitle>
                        <p className="text-gray-500">NA</p>
                    </Details.Row>
                    <Details.Row>
                        <Details.RowTitle>Filters</Details.RowTitle>
                        <Filters filters={message?.recipient_filters} />
                    </Details.Row>
                </Details.Content>
            </Details.Root>
            <Separator />
            <Details.Root>
                <Details.Title>From:</Details.Title>
                <Details.Content>
                    <Details.Row className="border-b border-gray-100">
                        {message?.sender?.email}
                    </Details.Row>
                    <Details.Row>
                        <Details.RowTitle>Sender</Details.RowTitle>
                        {message?.sender?.value}
                    </Details.Row>
                </Details.Content>
            </Details.Root>
            <Separator />
            <Details.Root>
                <Details.Title>Subject:</Details.Title>
                <Details.Content>
                    <Details.Row className="border-b border-gray-100">
                        {message.subject}
                    </Details.Row>
                    <Details.Row>
                        <Details.RowTitle>Attachments</Details.RowTitle>
                        <div className="flex flex-wrap gap-x-2">
                            {!message.media.length && 'NA'}
                            {message.media.map(media => (
                                <a
                                    href={media.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    key={media.id}
                                    className="flex items-center gap-2"
                                >
                                    <FontAwesomeIcon icon={faPaperclip} />
                                    <span className="text-brand-cobalt-primary">{media.name}</span>
                                </a>
                            ))}
                        </div>
                    </Details.Row>
                </Details.Content>
            </Details.Root>
            <Separator />
        </div>
    );
};

const Filters = ({ filters }: { filters: OutboundFilters | null }) => {
    const { didInit } = useFiltersByKey('engage');
    useInitFilters('engage', transformSavedFilterGroups(filters ?? []));

    if (!didInit || !filters) return <p className="text-gray-500">NA</p>;

    return (
        <FilterProvider resource={'contacts'} cacheKey={'engage'} readOnly={true}>
            <FilterGroupProvider showInnerOperator={false} showOuterOperator={false}>
                <FilterGroupBar />
            </FilterGroupProvider>
        </FilterProvider>
    );
};

export { EngageMetricsDetails };
